import { request4 } from '@/service/request4'

export function getIndexDetail() {
  return request4({
    url: '/manager/admin/dashboard-statics/10000',
    method: 'post'
  })
}
